module.exports = __webpack_public_path__ + "img/icons_11.cc110284.svg";